import type { SWRResponse } from "swr";
import type { UseQueryOptions } from "rivals/shared/hooks/useQuery/useQuery";
import useQuery from "rivals/shared/hooks/useQuery/useQuery";
import type { Article } from "rivals/shared/interfaces/Content";

export default function useFetchContent(
  id: number | string,
  options?: UseQueryOptions
): SWRResponse<Article> {
  const url = `/api/v2/content/contents/${id}`;

  return useQuery<Article>(url, options);
}
